// extracted by css-extract-rspack-plugin
module.exports =  {"movieReview":"v19rq","img":"gn0Wk","content":"ZkN38","flexbox":"PEeJi","rating":"TBcPp","isSlide":"xiP70","cardSlider":"O8JFE","newCard":"fmnkr"};